import graphqlClient from '@/graphql/graphql-client';
import { useMutation } from '@tanstack/react-query';
import {
  UpdateTaskManagerItemDocument,
  type UpdateTaskManagerItemMutationVariables,
} from '@/graphql/generated/graphql';

export type UpdateTaskManagerItemVariables = UpdateTaskManagerItemMutationVariables;

export const useUpdateTaskManagerItem = () => {
  const mutation = useMutation({
    mutationKey: ['update-task-manager-item'],
    mutationFn: (variables: UpdateTaskManagerItemMutationVariables) =>
      graphqlClient.request(UpdateTaskManagerItemDocument, variables),
  });

  return {
    ...mutation,
    updateTaskManagerItem: mutation.mutate,
    updateTaskManagerItemAsync: mutation.mutateAsync,
  };
};

export const UPDATE_TASK_MANAGER_ITEM_MUTATION = UpdateTaskManagerItemDocument;
